import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("vs_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401) {
      localStorage.removeItem("vs_token");
      localStorage.removeItem("vs_user");
    }
    return Promise.reject(err);
  }
);

export function saveAuth(token, user) {
  localStorage.setItem("vs_token", token);
  localStorage.setItem("vs_user", JSON.stringify(user));
}

export function loadUser() {
  try {
    const raw = localStorage.getItem("vs_user");
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuth() {
  localStorage.removeItem("vs_token");
  localStorage.removeItem("vs_user");
}
